import { Section, TableOfContent } from '../../../typings/interfaces';
import { ENGLISH } from '../../../assets/images';

// English
const ENSection: Section[] = [
  {
    name: '1: Reference and Overview',
    subSections: [
      {
        name: 'Preface',
        page: 3,
      },
      {
        name: 'Purpose and Field Guide Applications',
        page: 4,
      },
      {
        name: 'Key Definitions',
        page: 5,
      },
      {
        name: 'Hierarchy of Controls',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'Motor Vehicle – Traffic Safety',
        page: 9,
      },
      {
        name: 'Working at Height',
        page: 12,
      },
      {
        name: 'Mobile Powered Equipment (MPE)',
        page: 18,
      },
      {
        name: 'Lockout Tagout / Energy Isolation',
        page: 22,
      },
      {
        name: 'Electrical Work',
        page: 25,
      },
      {
        name: 'Confined Space',
        page: 29,
      },
      {
        name: 'Bulk Material & Storage',
        page: 32,
      },
      {
        name: 'Railcar Safety',
        page: 37,
      },
      {
        name: 'Excavation and Trench Work',
        page: 41,
      },
      {
        name: 'Lifting & Rigging ',
        page: 45,
      },
      {
        name: 'Hazardous Materials',
        page: 49,
      },
      {
        name: 'Hot Work',
        page: 52,
      },
    ],
  },
  {
    name: '3: Additional Resources and Tools',
    subSections: [
      {
        name: 'Working Over and Around Water',
        page: 56,
      },
      {
        name: 'Dropped Objects - Drop Calculator',
        page: 59,
      },
      {
        name: 'Atmospheric/Gas Testing',
        page: 61,
      },
      {
        name: 'Chemical Hazard Communication',
        page: 65,
      },
    ],
  },
  {
    name: '4: Cargill Safety Management Practices',
    subSections: [
      {
        name: 'Key Terminology',
        page: 70,
      },
      {
        name: 'Event Serious Injury and Fatality (SIF) Determination',
        page: 72,
      },
      {
        name: 'Serious Injury and Fatality Potential (SIFp) Categorization',
        page: 73,
      },
      {
        name: 'SIF Automatic Determination Criteria Table',
        page: 74,
      },
      {
        name: 'Human & Organizational Performance (HOP)',
        page: 76,
      },
    ],
  },
];

const ENTableOfContent: TableOfContent = {
  language: 'en',
  sections: ENSection,
  label: 'Table of Contents',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Guide_ENGLISH.pdf',
  hopPocket: 'HOP Pocket Guide',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/EN_HOP_POCKET_GUIDE.pdf',
  source: ENGLISH,
};

export default ENTableOfContent;
